// @ts-nocheck

import { BetslipTypes, BetslipStatus, BetslipNotableCases } from '../types/history';
import type { BetslipType, BetslipStatusType, BetslipNotableCase } from '../types/history';

export default (
  status: BetslipStatusType,
  type: BetslipType,
  value: number,
  betAmount: number,
  winningsAmount: number,
  isAllBetbuilder: boolean,
  isOneOutcomeLost: boolean,
  isAllOutcomeLost: boolean,
): BetslipNotableCase => {
  // CANCELLED
  if (status === BetslipStatus.CANCELLED) {
    return BetslipNotableCases.CANCELLED;
  }
  // BETBUILDER
  if (isAllBetbuilder) {
    // running
    if (status === BetslipStatus.RUNNING) {
      return BetslipNotableCases.MYMATCH_RUNNING;
    }
    // win
    if (status === BetslipStatus.SETTLED && winningsAmount > 0) {
      if (value < 20) {
        return BetslipNotableCases.MYMATCH_LOW;
      }
      return BetslipNotableCases.MAN_OF_MYMATCH;
    }
    // lost
    if (status === BetslipStatus.SETTLED) {
      return BetslipNotableCases.MYMATCH_LOST;
    }
  }
  // CASHOUT
  if (status === BetslipStatus.CASHOUT) {
    // on cashout bet, winningsAmount = cashoutAmount
    if (winningsAmount < betAmount) {
      return BetslipNotableCases.CASHOUT_LOW;
    }
    if (winningsAmount >= betAmount * 5 && isOneOutcomeLost) {
      return BetslipNotableCases.CASHOUT_HEROES;
    }
    return BetslipNotableCases.CASHOUT_OTHER;
  }
  // SYSTEM
  if (type === BetslipTypes.SYSTEM) {
    // running
    if (status === BetslipStatus.RUNNING) {
      return BetslipNotableCases.SYSTEM_RUNNING;
    }
    // win
    if (status === BetslipStatus.SETTLED && winningsAmount > 0) {
      return BetslipNotableCases.SYSTEM_WINNING;
    }
    // lost
    if (status === BetslipStatus.SETTLED) {
      return BetslipNotableCases.SYSTEM_LOST;
    }
  }
  // MULTIPLE
  if (type === BetslipTypes.MULTIPLE) {
    // running
    if (status === BetslipStatus.RUNNING) {
      if (value < 1.5) {
        return BetslipNotableCases.COMBO_RUNNING_LOW;
      }
      if (value < 20) {
        return BetslipNotableCases.COMBO_RUNNING_MIDDLE;
      }
      return BetslipNotableCases.COMBO_RUNNING_HIGH;
    }
    // win
    if (status === BetslipStatus.SETTLED && winningsAmount > 0) {
      if (value < 1.5) {
        return BetslipNotableCases.COMBO_WINNING_LOW;
      }
      if (value < 20) {
        return BetslipNotableCases.COMBO_WINNING_MIDDLE;
      }
      return BetslipNotableCases.MORTAL_COMBO;
    }
    // lost
    if (status === BetslipStatus.SETTLED) {
      if (isAllOutcomeLost) {
        return BetslipNotableCases.COMBO_LOST_ALL;
      }
      if (isOneOutcomeLost) {
        return BetslipNotableCases.COMBO_LOST_ONE;
      }
      return BetslipNotableCases.COMBO_LOST_OTHER;
    }
  }
  // SIMPLE
  if (type === BetslipTypes.SINGLE) {
    // running
    if (status === BetslipStatus.RUNNING) {
      if (value < 1.2) {
        return BetslipNotableCases.SINGLE_RUNNING_LOW;
      }
      if (value < 10) {
        return BetslipNotableCases.SINGLE_RUNNING_MIDDLE;
      }
      return BetslipNotableCases.SINGLE_RUNNING_HIGH;
    }
    // win
    if (status === BetslipStatus.SETTLED && winningsAmount > 0) {
      if (value < 1.2) {
        return BetslipNotableCases.SINGLE_WINNING_LOW;
      }
      if (value < 10) {
        return BetslipNotableCases.SINGLE_WINNING_MIDDLE;
      }
      return BetslipNotableCases.COTE_KILLER;
    }
    // lost
    if (status === BetslipStatus.SETTLED) {
      if (value < 1.2) {
        return BetslipNotableCases.SINGLE_LOST_LOW;
      }
      return BetslipNotableCases.SINGLE_LOST_OTHER;
    }
  }
  return BetslipNotableCases.SINGLE_RUNNING_LOW;
};
